import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loadPMResultsList, clearAll } from "../../../actions/admin";

import PMResultsList from "./PMResultsList";

const PMResults = ({
  pmresultsList,
  loadPMResultsList,
  pmresultsListLoading,
  user,
  selectedUser,
  clearAll,
  schoolYears,
}) => {
  useEffect(() => {
    if (pmresultsList.length === 0 && pmresultsListLoading && user !== null) {
      if (
        user.UserTypeID === 6 ||
        user.UserTypeID === 3 ||
        user.UserTypeID === 4
      ) {
        loadPMResultsList(selectedUser.UserID);
      } else {
        loadPMResultsList(selectedUser.UserID);
      }
    }
  }, [
    pmresultsList,
    pmresultsListLoading,
    loadPMResultsList,
    selectedUser,
    user,
  ]);

  const hist = useHistory();

  const studentsList = (arr) => {
    // Admin role and Super Admin Role-Retrieve all result list
    if (user.UserTypeID !== 1) {
      return arr;
    }
    // For teacher role, see the assigned assessment of current year only
    else {
      let students = [];

      const currentYear = schoolYears?.endYear || new Date().getFullYear() + 1;
      const res = arr.filter((student) => student.year === currentYear);

      return res;
    }
  };

  return (
    <div className="w-100">
      <PMResultsList
        isPMMode={true}
        pmresultsList={studentsList(pmresultsList)}
        pmresultListLoading={pmresultsListLoading}
        user={user}
        selectedUser={selectedUser}
      />
    </div>
  );
};
PMResults.propTypes = {
  pmresultsList: PropTypes.array,
  loadPMResultsList: PropTypes.func.isRequired,
  pmresultsListLoading: PropTypes.bool,
  clearAll: PropTypes.func.isRequired,
  user: PropTypes.object,
  schoolYears: PropTypes.object,
};
const mapStateToProps = (state) => ({
  pmresultsList: state.admin.pmresultsList,
  pmresultsListLoading: state.admin.pmresultsListLoading,
  user: state.auth.user,
  selectedUser: state.admin.user,
  schoolYears: state.admin.schoolYears,
});

export default connect(mapStateToProps, {
  loadPMResultsList,
  clearAll,
})(PMResults);
